import { ContextHolder } from '@frontegg/react';
import { clearDebugData, isDebugMode } from '../../debug/debugUser';
import { clearBootCache } from '../boot-cache/bootCache';

export function logout() {
  if (isDebugMode()) {
    clearDebugData();
    window.location.reload();
    return;
  }
  const baseUrl = ContextHolder.getContext().baseUrl;
  // The cached boot reads belong to this user, so they go before the page does.
  return clearBootCache(300).finally(() => {
    window.location.href = `${baseUrl}/oauth/logout?post_logout_redirect_uri=${window.location.origin}`;
  });
}
